<template>

</template>

<script>

import {Link} from "@inertiajs/vue3";

export default {
    data() {
        return {

        }
    },
    components: {
        Link
    },


}
</script>
